var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps4-content"},[_c('img',{attrs:{"src":require("../../../assets/image/password-success-icon.png"),"alt":"密码重置成功"}}),_c('div',[_vm._v("密码重置成功")]),_c('div',{on:{"click":_vm.resetLogin}},[_vm._v("重新登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }